import MatchingFeatureWizardForm from './MatchingFeatureWizardForm.component';

export default MatchingFeatureWizardForm;